export default __webpack_public_path__ + "static/malgorzata_alingua-b3e08e8a4309ae3e370c17ffe681b47d.jpg";